import { initMetrics } from "@expert/cloudwatch-metrics";
import { setAppcuesIdentifier, setFullStoryIdentifier, trackAppcuesEvent } from "@expert/monitoring";
import { appcuesBaseAttributes } from "@expert/monitoring/src/appcues";
import { useEffect } from "react";
import { useExpertAssistStore } from "../state";
import { env } from "../utils/env";
import { useIsTabActive } from "../utils/useIsTabActive";
import { initEaStoreSubscriptions } from "./initEaStoreSubscriptions";
import { initLoggerStoreSubscriptions } from "./initLoggerStoreSubscriptions";

export function useInitializers() {
    const { expertProfile, partner, token } = useExpertAssistStore();

    useIsTabActive();

    useEffect(() => {
        initEaStoreSubscriptions();
        initLoggerStoreSubscriptions();
    }, []);

    useEffect(() => {
        if (token) {
            initMetrics({
                accessToken: token,
                collectorUrl: env.metricsCollectorUrl,
                metricsNamespace: "ExpertAssist",
            });
        }
    }, [token]);

    useEffect(() => {
        setFullStoryIdentifier({
            identity: expertProfile.id,
            displayName: expertProfile.email,
            properties: {
                name: `${expertProfile.firstName} ${expertProfile.lastName}`,
                email: expertProfile.email,
                employeeId: expertProfile.id,
            },
        });

        setAppcuesIdentifier({
            identity: expertProfile.id,
            name: `${expertProfile.firstName} ${expertProfile.lastName}`,
            email: expertProfile.email,
        });

        if (expertProfile.id) {
            trackAppcuesEvent("Workspace Loaded", {});
        }
    }, [expertProfile]);

    useEffect(() => {
        appcuesBaseAttributes.partner = partner;
    }, [partner]);
}
